module.exports = "\r\n\r\n<app-login></app-login>\r\n\r\n"